module.exports = require('./helpers/bundle-url').getBundleURL('5Yk8B') + "logo-dark.eefe0b7f.svg";